export default "__VITE_ASSET__DL9wc3uC__"